import React from "react";
import PropTypes from "prop-types";
import { cn } from "../cn";
import styles from "./Input.module.scss";

/** Input — 1px border that transitions to primary on focus with a 2px ring. */
const Input = React.forwardRef(function Input(
  { invalid = false, mono = false, className, ...rest },
  ref
) {
  return (
    <input
      ref={ref}
      className={cn(
        styles.input,
        invalid && styles.invalid,
        mono && styles.mono,
        className
      )}
      {...rest}
    />
  );
});

Input.propTypes = {
  invalid: PropTypes.bool,
  mono: PropTypes.bool,
  className: PropTypes.string,
};

export default Input;
